import { SelectOption } from 'components/forms/Select';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { useIndustryTypes } from 'custom_hooks/data_hooks/industries/useIndustryTypes';
import { CorporationsTableCellProps } from 'pages/Settings/Corporations/CorporationsTable';
import { useMemo } from 'react';
import { updateCorporation } from 'utils/corporation';

export function CorporationIndustryCell({
    rowData,
    onChange,
}: CorporationsTableCellProps) {
    const { canEditCorporationSettings } = usePermissions();
    const { Industry } = rowData;

    const selectedOption = useMemo(
        () =>
            Industry
                ? { title: Industry.IndustryName, value: Industry.IndustryId }
                : undefined,
        [Industry]
    );

    const industryOptions = useIndustryTypes();

    const onSave = async (newValue: SelectOption | undefined) => {
        if (!newValue) {
            throw new Error('Attempted to save industry type without a value');
        }
        try {
            onChange(
                await updateCorporation(rowData, {
                    IndustryId: newValue.value as number,
                })
            );
        } catch {
            return 'Unable to save industry type.';
        }
        return undefined;
    };

    return (
        <DropdownInlineEditor
            options={industryOptions}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.title,
                dataKey: (item) => item.value,
                renderItem: ({ item }) => item.title,
                popup: { width: '16rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.title}
            onConfirm={onSave}
            isDisabled={!canEditCorporationSettings}
        />
    );
}
